import { addPermissionsToOrganisationRole } from '@infuse/api/iam/organisation';
import { addPermissionsToRole as addPermissionsToGlobalRole } from '@infuse/api/iam/role';
import { addPermissionsToRole as addPermissionsToTenantRole } from '@infuse/api/iam/tenant';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { useGenericAddPermissionToRole } from './generic/useGenericAddPermissionToRole';

export const useAddPermissionToRole = (forcedLevel?: UserLevel, forcedParentId?: string) => {
  const { level, user } = useCurrentUserStore();

  if ((forcedLevel || level) === UserLevel.TENANT) {
    return useGenericAddPermissionToRole({
      apiFn: addPermissionsToTenantRole,
      forcedParentId: forcedParentId || user?.tenantId
    });
  } else if ((forcedLevel || level) === UserLevel.ORGANISATION) {
    return useGenericAddPermissionToRole({
      apiFn: addPermissionsToOrganisationRole,
      forcedParentId: forcedParentId || user?.organisationId
    });
  }

  return useGenericAddPermissionToRole({
    apiFn: addPermissionsToGlobalRole
  });
};
